import { ToolboxItem } from '../../canvas/tooling/ToolboxItem';
import { gadgetTool } from './GadgetTool';
import { GadgetWidget } from './GadgetWidget';

export const gadgetToolboxItem = ToolboxItem({
    id: 'gadgets',
    label: 'Gadgets',
    icon: 'deqo://icons/d2/gadget',
    weight: 3045,
    ui: GadgetWidget,
    tools: [
        gadgetTool,
    ]
});
